import { DataGrid } from "@mui/x-data-grid";
import { Box } from "@mui/material";
import styled from "@emotion/styled";
import { statusTableRow } from "../utils/download";

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
    "& .MuiDataGrid-columnHeaders": {
        backgroundColor: theme.palette.secondary.main,
    },
    "& .MuiDataGrid-row:nth-of-type(even)": {
        backgroundColor: theme.palette.secondary.main,
    },
    "& .MuiDataGrid-row:hover": {
        backgroundColor: theme.palette.secondary.dark,
    },
    "& .MuiDataGrid-columnHeaderTitle": {
        fontWeight: "bold",
    },
    /*  "& .MuiDataGrid-cell": {
       whiteSpace: "normal!important",
       wordWrap: "break-word!important",
       minHeight: '0!important',
       maxHeight: 'none!important',
     }, */
    fontSize: "11.6px",
}));

export default function DataTable(data) {

    const isStackedBarChart = Array.isArray(data.data.labels[0]);
    const isPyramid = Boolean(data.data.isPyramid);
    const unit = isPyramid ? 'Population' : data.data.info.unit;

    const years = isStackedBarChart
        ? data.data.labels.map((label) => label[0])
        : data.data.labels;

    const columns = [
        {
            field: "id",
            headerName: "",
            minWidth: 180,
        },
        {
            field: "unit",
            headerName: "Unit",
            minWidth: 80,
        },
        ...years.map((year) => ({
            field: year,
            headerName: year,
            minWidth: 30,
            renderCell: (params) => {
                const val = params.value;
                const footnote = params.row[`${params.field}_footnote`];
                if (val && footnote) {
                    return (
                        <span title={footnote} style={{ borderBottom: '1px dotted #888', cursor: 'help' }}>
                            {val} *
                        </span>
                    );
                }
                return <span>{val}</span>;
            }
        })),
    ];

    const rows = data.data.datasets.map((dataset) => {
        const row = { id: dataset.label, unit: dataset.unit || unit };

        years.forEach((year, index) => {
            let yValue;
            let footnote = "";

            if (isStackedBarChart || isPyramid) {
                yValue = Math.abs(dataset.data[index]);
                if (isStackedBarChart && dataset.flagDescriptions) {
                    footnote = dataset.flagDescriptions[index] || "";
                }
            } else {
                const dataPoint = dataset.data.find((point) => point.x === year);
                yValue = dataPoint && !isNaN(dataPoint.y) ? dataPoint.y : "";
                footnote = dataPoint ? (dataPoint.flagDescription || dataPoint.footnote || "") : "";

                // Same warning the chart tooltip carries: an annual value averaged over part of
                // a year is not comparable with the complete years next to it.
                const months = Number(dataPoint?.monthsObserved);
                if (Number.isFinite(months) && months > 0 && months < 12) {
                    footnote = [`Average of ${months} of 12 months`, footnote].filter(Boolean).join(" - ");
                }
            }

            row[year] = yValue && !isNaN(yValue) ? Number(yValue).toFixed(2) : "";
            row[`${year}_footnote`] = footnote;
        });

        return row;
    });

    // Same row the download writes, so the file and the table agree.
    const status = data.data.isStatus ? statusTableRow(data.data, data.tableTitle) : null;
    const statusColumns = status && [
        columns[0],
        columns[1],
        { field: status.year, headerName: status.year, minWidth: 30 },
    ];
    const statusRows = status && [{ id: status.row.Label, unit: status.row.Unit, [status.year]: status.row[status.year] }];

    return (
        <Box className="max-chart-height">
            <StyledDataGrid
                sx={{
                    margin: "0 10px 10px 10px",
                    height: "95%",
                    boxShadow: 2,
                    maxWidth: { xs: '90vw', md: '65vw', lg: "53vw", xl: "56vw" },
                }}
                rows={statusRows || rows}
                columns={statusColumns || columns}
                hideFooter
            />
        </Box>
    );
}
